import React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 2,
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    main: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#FFFF',
    },
    logo: {
      width: 'auto',
      height: '30px',
      margin: ' 0px 3px',
    },
    gif: {
      height: '550px',
      maxWidth: '100%',
      [theme.breakpoints.down('sm')]: {
        height: '450px',
      },
    },
    footerContent: {
      display: 'flex',
      alignItems: 'center',
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      [theme.breakpoints.between('sm', 'md')]: {
        justifyContent: 'center',
      },
      flexGrow: 2,
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      backgroundColor: '#ECF0F1',
    },
    powered: {
      color: '#5D6D7E',
    },
    hide: {
      display: 'none',
    },
  })
);

export default function NetworkError() {
  const classes = useStyles();
  const { networkError } = useVideoContext();

  return (
    <>
      <div className={networkError ? classes.main : classes.hide}>
        <video
          className={classes.gif}
          autoPlay
          loop
          muted
          preload="auto"
          src={require('../../assests/gif/noInternetConnection.mp4')}
        ></video>
        <div className={classes.container}>
          <div className={classes.footer}>
            <div className={classes.footerContent}>
              <span className={classes.powered}>Powered by</span>
              <img
                className={classes.logo}
                src={require('../../assests/images/zuper-trans-logo.png')}
                alt="zuper_logo"
              ></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
